module.exports = __webpack_public_path__ + "static/Portfolio17-f7596c41c01ee64e4e22c7c4ab963b3f.jpg";